import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import {
  fetchInteraction,
  clearInteractionStore,
  sendMessage,
  attachFiles,
  removeAttachment,
  inputMessageHandler,
  showWarningFileSize
} from '../../../ducks/interaction'

import Preloader from '../../../components/UI/Preloader'
import TopBarContainer from '../../Interaction/TopBarContainer'
import InfoBar from '../../Interaction/InfoBar'
import MessageList from '../../../components/Interaction/MessageList'
import ResponseForm from '../../../components/Interaction/ResponseForm'

const InteractionPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: ${(props) => props.containerHeight}px;

  overflow: hidden;

  background-color: #fff;
  border: 1px solid #eeeff1;
  border-radius: 4px;
`

const StyledMessagesWrapper = styled.div`
  overflow-y: scroll;
  width: 100%;
  flex: 1 1 auto;
  align-items: stretch;
`

class InteractionPage extends Component {
  constructor(props) {
    super(props)

    this.containerRef = React.createRef()
  }

  scrollToBotton = () => {
    this.containerRef.current.scrollTop = this.containerRef.current.scrollHeight
  }

  componentDidMount() {
    const { id } = this.props.match.params
    const { selectedInteractionId } = this.props.interaction

    this.scrollToBotton()

    if (selectedInteractionId !== id) {
      this.props.fetchInteraction(id)
    }
  }

  componentDidUpdate(prevProps) {
    const oldEvents = prevProps.interaction.events
    const oldEvent = oldEvents[oldEvents.length - 1] || { date: '' }

    const newEvents = this.props.interaction.events
    const newEvent = newEvents[newEvents.length - 1]

    if (newEvent && oldEvent.date !== newEvent.date) {
      this.scrollToBotton()
    }
  }

  componentWillUnmount() {
    this.props.clearInteractionStore()
  }

  render() {
    const { interaction, containerHeight, showWarningFileSize } = this.props
    const { loading, data, events, files, messageText } = interaction
    const { state } = data

    return (
      <InteractionPageWrapper containerHeight={containerHeight}>
        {loading && <Preloader />}
        <TopBarContainer />
        <StyledMessagesWrapper ref={this.containerRef}>
          <InfoBar data={data} message={events[0]} />
          <MessageList events={events.slice(1)} />
        </StyledMessagesWrapper>

        {state !== 'Closed' && (
          <ResponseForm
            messageText={messageText}
            inputMessageHandler={this.props.inputMessageHandler}
            removeAttachment={this.props.removeAttachment}
            files={files}
            attachFiles={this.props.attachFiles}
            sendMessage={this.props.sendMessage}
            showWarningFileSize={showWarningFileSize}
          />
        )}
      </InteractionPageWrapper>
    )
  }
}

export default connect(
  ({ interaction }) => ({ interaction }),
  {
    fetchInteraction,
    clearInteractionStore,
    sendMessage,
    attachFiles,
    removeAttachment,
    inputMessageHandler,
    showWarningFileSize
  }
)(InteractionPage)
